module.exports = __webpack_public_path__ + "img/reutova.7d57ff92.jpg";